<template>
  <div>
    <p id="dashboardItemTitle">Expired Document List</p>

    <div class="columns">
      <div class="column is-3 is-offset-8">
        <b-field>
          <b-input placeholder="Search data" v-model="searchKeyword" type="search" icon="magnify"></b-input>
        </b-field>
      </div>
    </div>

    <div style="margin-top: 30px">

      <section v-if="!isLoading">

        <template v-if="tableRows.length < 1" >
          <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
            <span class="ml-2 has-text-grey-lighter">No records to display</span>
          </div>
        </template>
        <b-table
            v-else
            :data="filterTableData(tableRows,searchableFields,searchKeyword)"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :hoverable="isHoverable"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :sticky-header="stickyHeaders"

            pagination-size="is-small"
            default-sort="reference_id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">


          <b-table-column field="document_crated_by" label="Created By" width="120" sortable v-slot="props" centered>
            {{ props.row.document_crated_by }}
          </b-table-column>

          <b-table-column field="document_name" label="Document Name" sortable v-slot="props" centered>
            {{ props.row.document_name }}
          </b-table-column>

          <b-table-column field="document_status" label="Status" sortable v-slot="props" centered>
            {{ props.row.document_status }}
          </b-table-column>

          <b-table-column field="other_invitees" label="Recipients" sortable v-slot="props" centered>
            {{ props.row.other_invitees }}
          </b-table-column>

          <b-table-column field="document_crated_at" label="Timestamp" sortable v-slot="props" centered>
            {{ DateFormat(props.row.document_crated_at) }}
          </b-table-column>

          <b-table-column field="document_action" label="Action" v-slot="props" centered>
            <b-button size="is-small" type="is-info" icon-left="eye"
                      @click="$router.push(
            {name:'documentView',
            params:{
              document_id:props.row.document_uploads_table_id,
              }
            })">View</b-button>
          </b-table-column>

        </b-table>

      </section>

      <section v-else>
        <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>
      </section>

    </div>

  </div>
</template>
<script>
import axios from "axios";

export default {

  name:'declined-document',

  data(){
    return {
      tableRows:[], // to store pending documents
      isLoading:true,

      isPaginated: true,
      isHoverable: true,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      stickyHeaders: true,

      searchKeyword:'',

      searchableFields:['document_crated_by','document_name','document_status','other_invitees','document_crated_at)'],

      columns: [

        {
          field: 'created_by',
          label: 'Created By',
          width: '200',
          centered:true,

        },
        {
          field: 'title',
          label: 'Title',
          centered:true,
        },
        {
          field: 'status',
          label: 'Status',
          centered:true,
        },
        {
          field: 'recipient',
          label: 'Recipient',
          centered:true,
        }
      ]
    }
  },

  methods:{

    DateFormat:function(date)
    {
      //date formatting
      var d = new Date(date)
      var datestring = d.getFullYear() + "-"+ (d.getMonth()+1) + "-"+ d.getDate();

      console.log(datestring);

      //hours formatting
      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;

      var dateTime = datestring +' : '+ strTime
      return dateTime

      // console.log('dateformat js'+datestring);
    },

    filterTableData:function (sourceData, fields, keyword){

      var outputArray = [];
      sourceData.forEach(function(row){
        let pushed = false
        fields.forEach(function(fieldName){
          if(String(row[fieldName]).match(RegExp(keyword, "i")) && !pushed){
            outputArray.push(row)
            pushed = true
          }
        });
      });

      return outputArray
    },

    getExpiredDocuments(){

      const comp = this
      try {

        axios.post(comp.$base_url+'/agent/getCoordinatesInExpiredDocForAgent', {
          auth_token:comp.$root.agentAuthToken,
        })
            .then(function (response) {

              console.log("expired Documents data ---------------")
              console.log(response)

              if(response.data.success){
                console.log("expired documents : "+ response.data.data.DocumentList)
                comp.tableRows = response.data.data.DocumentList
                comp.isLoading = false
              }
              else{
                comp.$buefy.toast.open({
                  message: "Failed to get expired documents",
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to get expired documents",
                type: "is-danger",
              });
            });

      }
      catch (e) {
        comp.$buefy.toast.open({
          message: "Failed to get completed documents",
          type: "is-danger",
        });
        console.log("Exception occurred in Customer expired document page getexpiredDocuments() : "+e.message)
      }
    },


    validateToken:function (){  //check authentication
      var component = this

      axios.post(component.$base_url+'/agent/checkAuthentication', {
        auth_token:component.$root.agentAuthToken
      })
          .then(function (data) {
            var array =[]
            array = data.data


            console.log(array.data.message)
            if(array.success == true){
              console.log(array.data.message)
              //load department & template ctg
              component.getDataList()

            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }

          })
          .catch(function (error) {
            var array =[]
            array = error.response
            //session expired
            console.log(array.data.success)
            if(array.data.success == false){
              component.$buefy.toast.open({
                message: 'Authentication failed',
                type: 'is-danger'
              })
              component.$router.push({name:'agentSignin'})
            }
          });

    },
  },

  mounted() {
    this.getExpiredDocuments()
    this.validateToken()
  },

}

</script>
<style scoped>
#dashboardItemTitle{
  color: #A5A6B3;
  font-weight: 600;
  font-size: 30px;
  text-align: left
}
</style>
